import { type Leaderboard, LeaderboardCategory } from './model/types';

export const normalizeLeaderboard = (leaderboard: Leaderboard): Leaderboard => {
  return {
    ...leaderboard,
    prizes: leaderboard.prizes.sort((a, b) => a.placeFrom - b.placeFrom),
  };
};

export const getLeaderboardNameForAnalytics = (
  leaderboard: Pick<Leaderboard, 'category' | 'contestType' | 'partner'>
) => {
  if (leaderboard.category == LeaderboardCategory.PARTNER) {
    return leaderboard.partner ?? leaderboard.category;
  }

  return leaderboard.contestType;
};
